<div class="wo-contact-person">
  <div>
    <div class="wo-contact-person-name">{{ displayName }}</div>
    <div class="wo-contact-person-role">{{ person?.role | contactRole }}</div>
  </div>
  <div>
    <wo-icon-field *ngIf="person?.phoneNumber" [icon]="'phone'">
      <a href="tel: {{person!.phoneNumber}}">{{person!.phoneNumber}}</a>
    </wo-icon-field>
    <wo-icon-field *ngIf="person?.email" [icon]="'email'">
      <a href="mailto: {{person!.email}}">{{person!.email}}</a>
    </wo-icon-field>
  </div>
</div>
